import React, { useMemo } from 'react';
import { ReactTags } from 'react-tag-autocomplete';

function normalizeList(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (value && typeof value === 'object') {
    return Object.values(value);
  }
  return [];
}

function CurrencyTagsInput({
  value = [],
  options = [],
  onChange,
  placeholderText = 'Select one or more currencies',
  listMaxHeight = 200,
}) {
  const selectedValues = useMemo(
    () => normalizeList(value).map((item) => String(item || '').trim().toUpperCase()).filter(Boolean),
    [value],
  );

  const selectedTags = useMemo(
    () => selectedValues.map((item) => ({ value: item, label: item })),
    [selectedValues],
  );

  const suggestions = useMemo(
    () => normalizeList(options)
      .map((item) => {
        if (typeof item === 'string') {
          const normalized = item.trim().toUpperCase();
          return normalized ? { value: normalized, label: normalized } : null;
        }

        if (!item || typeof item !== 'object') {
          return null;
        }

        const valueField = String(item.value || item.code || item.currency || '').trim().toUpperCase();
        if (!valueField) {
          return null;
        }

        const labelField = String(item.label || item.name || valueField).trim() || valueField;
        return { value: valueField, label: labelField };
      })
      .filter(Boolean),
    [options],
  );

  const handleDelete = (tagIndex) => {
    if (!onChange) {
      return;
    }
    onChange(selectedValues.filter((_, index) => index !== tagIndex));
  };

  const handleAdd = (newTag) => {
    if (!onChange) {
      return;
    }

    const rawValue = typeof newTag?.value === 'string' && newTag.value.trim().length > 0
      ? newTag.value
      : (typeof newTag?.label === 'string' ? newTag.label : '');
    const nextValue = rawValue.trim().toUpperCase();

    if (!nextValue || selectedValues.includes(nextValue)) {
      return;
    }

    onChange([...selectedValues, nextValue]);
  };

  return (
    <div
      className="currency-tags-input"
      style={{ '--currency-tags-list-max-height': `${Number(listMaxHeight) || 200}px` }}
    >
      <ReactTags
        selected={selectedTags}
        suggestions={suggestions}
        allowNew={false}
        onDelete={handleDelete}
        onAdd={handleAdd}
        placeholderText={placeholderText}
      />
    </div>
  );
}

export default CurrencyTagsInput;
